import { createAsyncThunk } from '@reduxjs/toolkit';
import { getApiCertificatePdfData } from '@routes/system/certificate/api/certificate.api';
import { downloadFromDisposition } from '@utils/download';

export const getCertificatePdf = createAsyncThunk<void, number, { rejectValue: any }>(
    'certificate/pdf',
    (id, { rejectWithValue }) =>
        getApiCertificatePdfData(id)
            .then((res) => {
                downloadFromDisposition(res);
            })
            .catch((err) => rejectWithValue(err)),
);
